import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Stock } from '../stock.type';

/**
 * Arms one or many accounts with a stop threshold.
 *
 * coins_to_be_remain is where draining STOPS, not a target. Purchases are whole
 * cards, so the final balance lands at or just below it — stated here rather
 * than left for the supplier to discover.
 */
@Component({
  selector: 'app-stock-readiness-dialog',
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule],
  template: `
    <h2 mat-dialog-title>
      {{ data.stocks.length === 1 ? 'Mark account ready' : 'Mark ' + data.stocks.length + ' accounts ready' }}
    </h2>
    <mat-dialog-content>
      <p class="hint">
        Draining continues while the balance is above this value, then stops.
        Because cards are bought whole, the final balance is usually a little below it.
      </p>
      <mat-form-field appearance="outline" class="full">
        <mat-label>Stop threshold (coins)</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="threshold">
      </mat-form-field>
      @if (single && single.floor_raised_by_minimum) {
      <p class="warn">
        The platform minimum credit is {{ single.effective_floor | number }} coins, so the run
        will stop there rather than at a lower threshold.
      </p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="ref.close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="threshold === null || threshold < 0"
              (click)="ref.close(threshold)">Mark ready</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .full { width: 100%; }
    .hint { font-size: 12px; opacity: .75; line-height: 1.6; }
    .warn { font-size: 12px; color: #ef6c00; line-height: 1.6; }
  `],
})
export class StockReadinessDialog {
  threshold: number | null;
  single: Stock | null;

  constructor(
    public ref: MatDialogRef<StockReadinessDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { stocks: Stock[] },
  ) {
    this.single = data.stocks.length === 1 ? data.stocks[0] : null;
    // Prefill from the account's current threshold so re-arming one account
    // keeps its previous value unless it is deliberately changed.
    this.threshold = this.single ? this.single.coins_to_be_remain : 0;
  }
}
